import { css, unsafeCSS } from 'lit';
import { sbkCoreBreakpointMd, sbkCoreBreakpointLg, sbkCoreBreakpointXl } from "@/tokens/variables";

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);
const breakpointXl = unsafeCSS(`${sbkCoreBreakpointXl}`);

export const experiencesStyles = css`
    :host {
        display: block;
    }

    .tiles {
        margin-top: var(--sbkCoreSpacing2xl);

        @media all and (min-width: ${breakpointLg}) {
            margin-top: var(--sbkCoreSpacing3xl);
        }

        @media all and (min-width: ${breakpointXl}) {
            margin-top: var(--sbkCoreSpacing4xl);
        }

        .tiles__list {
            display: flex;
            flex-wrap: wrap;
            gap: 24px;
        }

        sbk-citation-teaser {
            display: block;
            height: min-content;
            overflow-y: auto;
            flex: 1 1 calc(100%);
            max-width: calc(100%);
            min-width: 350px;

            @media all and (min-width: ${breakpointLg}) {
                flex: 1 1 calc(50% - 16px);
                max-width: calc(50% - 16px);
            }

            @media all and (min-width: ${breakpointXl}) {
                flex: 1 1 calc(33.333% - 16px);
                max-width: calc(33.333% - 16px);
            }
        }

        .is-ie11 .tiles__list li {
            margin: 15px;    
            min-width: 350px;
            width: calc((100% / 5) - 30px);
        }

        @keyframes fadein {
            from {
                opacity:0;
            }
            to {
                opacity:1;
            }
        }
        @-moz-keyframes fadein { /* Firefox */
            from {
                opacity:0;
            }
            to {
                opacity:1;
            }
        }
        @-webkit-keyframes fadein { /* Safari and Chrome */
            from {
                opacity:0;
            }
            to {
                opacity:1;
            }
        }
        @-o-keyframes fadein { /* Opera */
            from {
                opacity:0;
            }
            to {
                opacity: 1;
            }
        }

        .tiles__element--disturber {
            background: #003c6e;
        }

        .tiles__element--disturber .tile--headline {
            color: #fff;
        }

        .tiles__element--disturber .primaryButton {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            min-height: 56px;
            margin-top: 24px;
        }

        @media (min-width: ${breakpointMd}) {
            .tiles__element--disturber .primaryButton {
                margin-top: 30px;
            }
        }

        .tiles__element--disturber .primaryButton__icon {
            position: relative;
            top: -3px;
            width: 24px;
            height: 24px;
            margin-right: 12px;
        }

        .tiles__element--disturber .primaryButton__icon svg {
            width: 24px;
            height: 24px;
        }

        .quotation-mark {
            position: absolute;
            top: 0;
            right: 0;
            opacity: .08;
            transform: translateY(-30%);
        }

        .toggle__show-more {
            text-align: center;
            margin-top: var(--sbkCoreSpacing3xl);
        }

        .toggle__show-more-icon {
            font-size: 24px;
        }
    }
`;